import { Controller } from "@hotwired/stimulus"

// MED-005 follow-up: the admin shell defaults to the dark palette, this button
// flips it to light and back. The choice lands in a cookie so the server
// renders the chosen theme on the next request and the page never flashes.
// MED-023: when somebody is signed in it is also written through to their own
// stored preference, so the choice follows the person and not the browser.
export default class extends Controller {
  static targets = ["icon"]
  static values = { lightLabel: String, darkLabel: String, url: String }

  toggle() {
    const container = this.element.closest(".app-container")
    if (!container) return

    const next = container.dataset.bsTheme === "dark" ? "light" : "dark"
    container.dataset.bsTheme = next
    document.cookie = `admin_theme=${next};path=/;max-age=31536000;samesite=lax`
    this.render(next)
    this.store(next)
  }

  // A POST, never a GET side effect. The cookie above already carries the flip,
  // so a failure here costs the cross-device memory and nothing else.
  store(theme) {
    if (!this.hasUrlValue) return

    fetch(this.urlValue, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
      },
      body: JSON.stringify({ theme })
    })
  }

  connect() {
    const container = this.element.closest(".app-container")
    this.render(container ? container.dataset.bsTheme : "dark")
  }

  render(theme) {
    const toLight = theme === "dark"
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("bi-sun", toLight)
      this.iconTarget.classList.toggle("bi-moon", !toLight)
    }
    const label = toLight ? this.lightLabelValue : this.darkLabelValue
    if (label) this.element.setAttribute("aria-label", label)
  }
}
